(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (document.body.classList.contains('ms-mega-menu-open')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reverie-contact-process"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initProcessPager = (root) => {
    if (!root || root.dataset.reverieProcessPagerReady === 'true') return;

    const list = root.querySelector('[data-reverie-process-list]');
    const slides = [...root.querySelectorAll('[data-reverie-process-slide]')];
    const pagers = [...root.querySelectorAll('[data-reverie-process-pager]')];

    if (!list || slides.length < 2 || pagers.length !== slides.length) return;

    root.dataset.reverieProcessPagerReady = 'true';
    let frame = 0;

    const targetLeft = (index) => slides[index].offsetLeft - slides[0].offsetLeft;

    const selectPager = (activeIndex) => {
      pagers.forEach((pager, index) => {
        const isActive = index === activeIndex;
        pager.classList.toggle('is-active', isActive);
        if (isActive) pager.setAttribute('aria-current', 'true');
        else pager.removeAttribute('aria-current');
      });
    };

    const syncPager = () => {
      frame = 0;
      let activeIndex = 0;
      let nearestDistance = Infinity;

      slides.forEach((slide, index) => {
        const distance = Math.abs(targetLeft(index) - list.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          activeIndex = index;
        }
      });

      selectPager(activeIndex);
    };

    list.addEventListener(
      'scroll',
      () => {
        if (frame) return;
        frame = requestAnimationFrame(syncPager);
      },
      { passive: true }
    );

    pagers.forEach((pager, index) => {
      pager.addEventListener('click', () => {
        list.scrollTo({
          left: targetLeft(index),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
        selectPager(index);
      });
    });

    syncPager();
  };

  const initAllProcessPagers = (scope = document) => {
    scope.querySelectorAll('.reverie-contact-process').forEach(initProcessPager);
  };

  initAllProcessPagers();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.matches?.('.reverie-contact-process')) initProcessPager(event.target);
    else initAllProcessPagers(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
